<div class="container">
    <input
        libInputFormatter="C2"
        [(ngModel)]="bindingProperty"
        (ngModelChange)="dataChanged($event)"
        [ngClass]="{ isReadOnly: isReadOnly, error: !isValid }"
        [readOnly]="isReadOnly"
        [placeholder]="(isReadOnly && !bindingProperty) || !label ? '' : 'Add ' + label"
        [tabIndex]="isReadOnly ? -1 : 0"
        [attr.aria-readonly]="isReadOnly"
    />
    <app-validation-error-message [show]="!isValid" [errors]="validationErrors"></app-validation-error-message>
</div>
